import { render } from "./vl-range-selector.vue?vue&type=template&id=b04f8c6c"
import script from "./vl-range-selector.vue?vue&type=script&lang=js"
export * from "./vl-range-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__